import { apiClient } from "../apiClient";

export const KHOI_NGANH_API = "khoi-nganh";
export const khoiNganhApi = {
    SelectAll: () => apiClient.get(`${KHOI_NGANH_API}`),
};
